// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SearchableDropdown_dropdown__uZ4dL {
  position: relative;
  width: 100%;
}
.SearchableDropdown_dropdown__uZ4dL label {
  color: rgba(27, 31, 59, 0.65);
  width: 100%;
  display: flex;
}

.SearchableDropdown_dropdownHeader__De48V {
  padding: 10px 0;
  cursor: pointer;
  background-color: white;
  font-size: 1rem;
  color: #121b3f;
}

.SearchableDropdown_dropdownBody__6HnZM {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  border: 1px solid #ccc;
  background-color: white;
  z-index: 10;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.SearchableDropdown_dropdownBody__6HnZM input {
  width: 100%;
  padding: 10px;
  box-sizing: border-box;
  border: none;
  border-bottom: 1px solid #ccc;
  outline: none;
}

.SearchableDropdown_dropdownList__w9e\\+Z {
  list-style: none;
  margin: 0;
  padding: 0;
  max-height: calc(100vh - 80vh);
  overflow-y: auto;
}

.SearchableDropdown_dropdownItem__xM3EC {
  padding: 10px;
  cursor: pointer;
}

.SearchableDropdown_dropdownItem__xM3EC:hover {
  background-color: #f0f0f0;
}
`, "",{"version":3,"sources":["webpack://./src/components/searchableDropdown/SearchableDropdown.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,6BAA6B;EAC7B,WAAW;EACX,aAAa;AACf;;AAEA;EACE,eAAe;EACf,eAAe;EACf,uBAAuB;EACvB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,sBAAsB;EACtB,uBAAuB;EACvB,WAAW;EACX,wCAAwC;AAC1C;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,6BAA6B;EAC7B,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":[".dropdown {\n  position: relative;\n  width: 100%;\n}\n.dropdown label {\n  color: rgba(27, 31, 59, 0.65);\n  width: 100%;\n  display: flex;\n}\n\n.dropdownHeader {\n  padding: 10px 0;\n  cursor: pointer;\n  background-color: white;\n  font-size: 1rem;\n  color: #121b3f;\n}\n\n.dropdownBody {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  right: 0;\n  border: 1px solid #ccc;\n  background-color: white;\n  z-index: 10;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n}\n\n.dropdownBody input {\n  width: 100%;\n  padding: 10px;\n  box-sizing: border-box;\n  border: none;\n  border-bottom: 1px solid #ccc;\n  outline: none;\n}\n\n.dropdownList {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  max-height: calc(100vh - 80vh);\n  overflow-y: auto;\n}\n\n.dropdownItem {\n  padding: 10px;\n  cursor: pointer;\n}\n\n.dropdownItem:hover {\n  background-color: #f0f0f0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dropdown": `SearchableDropdown_dropdown__uZ4dL`,
	"dropdownHeader": `SearchableDropdown_dropdownHeader__De48V`,
	"dropdownBody": `SearchableDropdown_dropdownBody__6HnZM`,
	"dropdownList": `SearchableDropdown_dropdownList__w9e+Z`,
	"dropdownItem": `SearchableDropdown_dropdownItem__xM3EC`
};
export default ___CSS_LOADER_EXPORT___;
